import React, { useState, forwardRef, useImperativeHandle } from 'react';

const AdditionalData = forwardRef((props, ref) => {
  const [additionalData, setAdditionalData] = useState({
    advance: '',
    discount: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdditionalData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  useImperativeHandle(ref, () => ({
    getAdditionalData: () => additionalData,
    setAdditionalData: (data) => setAdditionalData(data)
  }));

  return (
    <section className="create-bill-section">
      <div className="create-bill-section-head">
        <div>
          <h2>Adjustments</h2>
          <p className="create-bill-section-hint">Advance received and discount applied</p>
        </div>
      </div>

      <div className="create-bill-grid">
        <div className="create-bill-field">
          <label htmlFor="advance">Advance</label>
          <input
            type="number"
            id="advance"
            name="advance"
            value={additionalData.advance}
            onChange={handleChange}
            min="0"
            step="any"
            placeholder="0.00"
          />
        </div>

        <div className="create-bill-field">
          <label htmlFor="discount">Discount</label>
          <input
            type="number"
            id="discount"
            name="discount"
            value={additionalData.discount}
            onChange={handleChange}
            min="0"
            step="any"
            placeholder="0.00"
          />
        </div>
      </div>
    </section>
  );
});

export default AdditionalData;
